import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Spinner from '../components/reusable/spinner/Spinner';
import { getSingleModel } from '../utils/helpers';
import DownloadAppBanner from '../components/reusable/DownloadAppBanner';

const PrivateRoute = ({ element, ...rest }) => {
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);

    const isAuthenticated = () => {
        return getSingleModel('auth')?.authUser?.authenticated;
    };

    useEffect(() => {
        if (isAuthenticated()) {
            setIsLoading(false);
        }
    }, []);

    const excludedRoutes = [];
    const showBanner = !excludedRoutes.includes(location.pathname);

    return isAuthenticated() ? (
        isLoading ? (
            <Spinner />
        ) : (
            <>
                {showBanner && <DownloadAppBanner />}
                <div className={showBanner ? 'mt-[80px]' : ''}>{element}</div>
            </>
        )
    ) : (
        <Navigate to='/login' state={{ from: location }} />
    );
};

export default PrivateRoute;
